/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-file-picker',
  templateUrl: './file-picker.component.html',
  styleUrls: ['./file-picker.component.scss']
})
export class FilePickerComponent implements OnInit, OnDestroy {
  @ViewChild('attachement') attachFileRef: ElementRef;

  selectedFile: any = '';
  ArrayOfSelectedFile: File[] = [];

  @Output() fileChanged: EventEmitter<any> = new EventEmitter();
  constructor(

  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  pickFile(): void {
    this.attachFileRef.nativeElement.click();
  }

  fileChangeEvent(event: any): void {
    if (event.target.files.length > 0) {
      const files = event.target.files;
      for (const f of files) {
        if (f.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          f.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          f.type === 'application/pdf' ||
          f.type === 'image/jpeg' ||
          f.type === 'image/png') {
          this.ArrayOfSelectedFile.push(f);
        }
      }
    }
    this.fileChanged.emit(this.ArrayOfSelectedFile);
  }

  removedSelectedFile(index: number): void {
    this.ArrayOfSelectedFile.splice(index, 1);
    this.fileChanged.emit(this.ArrayOfSelectedFile);
  }

}
